import { FamilyStreams } from "../../model/FamilyStreams";
import { apiService } from "../ApiService";

export const getStreams = () => {
  return apiService.get<FamilyStreams>({
    path: `v1/streams`,
    requiresAuthPolicy: "user",
  });
};
